import { Box, Grid, Stack, Tooltip, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";

import { MakeOptional } from "@mui/x-charts/internals";
import { DefaultizedPieValueType, PieValueType } from "@mui/x-charts";
import SimpleLabel from "../Label";
import { CHART_COLORS } from "../../config/constants/common";
import PieInitialLoader from "../../common-ui/loaders/pieLoading";


type DATA_TYPE=MakeOptional<PieValueType, "id">[]
interface PieProps {
  title: string;
  data?:DATA_TYPE;
  total?: number;
  loading?: boolean;
  height?: number;
}
const getArcLabelPercentage = (params: DefaultizedPieValueType,dataSet?:DATA_TYPE) => {
  const TOTAL = (dataSet)?.map((item) => item.value).reduce((a, b) => a + b, 0);
  if (TOTAL) {
    const percent = params.value / TOTAL;
    return { placeHolder: `${params.label ?? ""}: ${(percent * 100).toFixed(1)}%`, value:`${(percent * 100).toFixed(1)}%`}
  }
  return {placeHolder: String(params.label ?? ""), value:String(params.label ?? "") }
};
const DmmsPieChart = ({
  title,
  data,
  loading,
  total,
  height = 300,
}: PieProps) => {
  return (
    <Box width={"100%"}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        px={1}
        width={"100%"}
      >
        <SimpleLabel title={title} width={"100%"} />
        {total && <SimpleLabel title={`Total ${total}`} width={"100%"} />}
      </Stack>
      {loading ? (
        <Box mt={2}>
          <PieInitialLoader height={height} />
        </Box>
      ) : (
        <>
          {data && (
            <Stack
              height={height}
              sx={{ position: "relative" }}
              direction={"row"} 
              pl={2}
            >
              <PieChart
                resolveSizeBeforeRender={true}
                loading={loading}
                colors={CHART_COLORS}
                series={[
                  {
                    arcLabel:(p)=>p.label??'',
                    arcLabelMinAngle: 20,
                    data: data ?? [],
                    highlightScope: { fade: "global", highlight: "item" },
                    outerRadius: height>300 ? 200:130,
                    cx: height>300 ? 200:130,
                  },
                ]}
                height={height}
                slotProps={{
                  pieArcLabel: {
                    style: {
                      fontSize: 12,
                    },
                  },
                  legend: {
                    labelStyle: {
                      fontSize: 12,
                      display: "none",
                    },
                    itemMarkHeight: 0,
                    itemMarkWidth: 0,
                  },
                }}
              />


                <LegendCard data={data as   DATA_TYPE} height={height} />
   
            </Stack>
          )}
        </>
      )}
    </Box>
  );
};
export default DmmsPieChart;

interface LegendCardProps {
  data: DATA_TYPE;
  height?: number;
}

export const LegendCard = ({ data, height = 300 }: LegendCardProps) => {
  return (
    <Box
      sx={{
        height:height,
        py:2,
        overflowY: "auto",
        overflowX:'hidden',
        width:'100%',
        display:"flex",
        justifyContent:'center',
        alignItems:'center',
      }}
    >
      <Grid container spacing={1} maxHeight={height-50}>
        {data.map((item, i) => {
          const percentData=getArcLabelPercentage((item as DefaultizedPieValueType) ,(data as DATA_TYPE))
          return (
            <Grid item xs={12} sm={6} md={6} key={i}>
              <Tooltip title={`${percentData.placeHolder} , total=${item.value}` }>
                <Stack
                  direction={"row"}
                  alignItems={"flex-start"}

                  sx={{
                    "&:hover": {
                      bgcolor: "grey.200",
                      transform: "scale(1.01)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      bgcolor: CHART_COLORS[i % CHART_COLORS.length],
                      borderRadius: "1px",
                      mr: 1.5,
                      flexShrink: 0,
                      mt:0.2
                    }}
                  />

                  <Stack>
                  <Typography
                    fontSize={10}
                    fontWeight={500}
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.label?.toString() ?? ""} 
                  </Typography>
                 
                  <Typography
                    fontSize={10}
                    fontWeight={500}
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Value = {item.value}
                  </Typography>
                  <Typography
                    fontSize={10}
                    fontWeight={500}
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                  Percentage = {percentData.value} 
                  </Typography>

                  </Stack>

                </Stack>
              </Tooltip>
            </Grid>
          )
        }
    )}
      </Grid>
    </Box>
  );
};
